import { ReactNode } from "react"
import style from "./SelectionCheckbox.module.scss"
import { Checkbox } from "../Misc/Checkbox";

interface Props {
  label: string | ReactNode;
  checked: boolean;
  onClick: () => void;
}

export function SelectionCheckbox({
  label,
  checked,
  onClick
}: Props) {
  return (
    <div
      className={style.SelectionCheckbox}
      onClick={onClick}
    >
      <div style={{ margin: "0.7rem" }}>
        <Checkbox
          checked={checked}
        />
      </div>
      <span>
        {label}
      </span>
    </div>
  );
}
